import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import '../Component/Component.css';
import LogoutIcon from '@mui/icons-material/Logout'; // Importing a logout icon from Material UI
import IconButton from '@mui/material/IconButton'; //
import { useNavigate } from 'react-router-dom';

function NavBar({ user }) {
    const handleLogout = () => {
        navigate('/',);
        // Add your logout logic here
        console.log('User logged out');
    };
    const navigate = useNavigate();
    return (
        <Navbar className="bg-body-tertiary" bg="dark" data-bs-theme="dark">
            <Container>
                <Navbar.Brand href="#home"><h3 id='welcome-text'>Welcome {user.username}</h3></Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <IconButton onClick={handleLogout} color="inherit">
                            <LogoutIcon />
                        </IconButton>
                    </Navbar.Text>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBar;